import { render, staticRenderFns } from "./EditImgConvenio.vue?vue&type=template&id=f44364f2&"
import script from "./EditImgConvenio.vue?vue&type=script&lang=js&"
export * from "./EditImgConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports